<template>
  <span class="editInPlace__sticky">&#65279;
    <VDropdown
      placement="auto"
      class="editInplace__popover"
      :disabled="!enable"
      @apply-show="onPopoverOpen"
      @hide="isPopoverOpen = false"
    >
      <!-- Edit with Icon only -->
      <button
        v-if="enable && textIcon === ''"
        v-tooltip.right="label"
      >
        <IconWrap
          class="editInplace__icon"
          :class="{'editInplace__icon--discreet': modeDiscreet}"
          width="15"
          height="15"
          :aria-label="$t('generic.edit')"
        >
          <IconPencil />
        </IconWrap>
      </button>
      <!-- Edit with Text only -->
      <button
        v-if="enable && textIcon !== ''"
        class="flex italic items-center text-gray-300 text-sm"
      >
        {{ textIcon }}
      </button>
      <IconWrap
        v-if="!enable"
        v-tooltip.right="!enable && $t('generic.ownerLockedEdit')"
        class="editInplace__icon"
        width="17"
        height="17"
        :aria-label="$t('layout.icons.locked')"
      >
        <IconLock />
      </IconWrap>
      <template #popper>
        <form
          id="editTooltip"
          class="editInPlace__form"
          @submit.prevent="submit"
        >
          <textarea
            ref="editInPlace__input"
            :value="value"
            class="editInPlace__input scroll-y"
            required="true"
            @input="saveInput"
          />
          <button
            v-close-popper="true"
            class="btn btn__secondary mt-4"
            type="button"
            @click="cancel"
          >
            {{ $t('generic.cancel') }}
          </button>
          <button
            v-close-popper="value !== ''"
            v-tooltip.bottom="!isLoggedIn && { content: $t('generic.loginEdit', 1), show: isPopoverOpen }"
            class="btn btn__fitMode mt-4"
            :disabled="!isLoggedIn"
            type="submit"
          >
            {{ $t('generic.confirm') }}
          </button>
        </form>
      </template>
    </VDropdown>
  </span>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import IconLock from '@/assets/images/icons/Lock';
import IconPencil from '@/assets/images/icons/Pencil';
import IconWrap from '@/assets/images/icons';
import { useToast } from 'vue-toastification';

export default {
  name: 'CorrectionsEdit',

  components: {
    IconWrap,
    IconPencil,
    IconLock
  },

  props: {
    imageId: {
      type: Number,
      default: () => null
    },

    enable: {
      type: Boolean,
      default: () => false
    },

    modeDiscreet: {
      type: Boolean,
      default: () => false
    },

    defaultValue: {
      type: String,
      default: () => ''
    },

    type: {
      type: String,
      default: () => null
    },

    textIcon: {
      type: String,
      default: ''
    },

    label: {
      type: String,
      default: () => ''
    }
  },

  setup() {
    const toast = useToast();
    return { toast };
  },

  data() {
    return {
      isPopoverOpen: false
    };
  },

  computed: {
    value() {
      return this.list[`${this.imageId}_${this.type}`] || this.defaultValue;
    },

    ...mapState('corrections', ['list']),
    ...mapGetters('user', ['isLoggedIn'])
  },

  methods: {
    onPopoverOpen() {
      this.isPopoverOpen = true;
    },

    saveInput(e) {
      this.saveCorrection({ imageId: this.imageId, type: this.type, value: e.target.value });
    },

    async submit() {
      // Send to server only new correction
      if (this.value && this.value !== this.defaultValue) {
        const res = await this.sendCorrection({ imageId: this.imageId, type: this.type, value: this.value });

        this.toast.success(res.data.message);
      }
    },

    cancel() {
      this.revertCorrection({ imageId: this.imageId, type: this.type });
    },

    ...mapActions('corrections', ['saveCorrection', 'sendCorrection', 'revertCorrection'])
  }
};
</script>

<style lang="postcss">
.editInPlace__sticky{
  @apply inline whitespace-no-wrap;
}

.editInplace__popover{
  @apply inline-block whitespace-no-wrap;
  vertical-align: top;
}

.editInPlace__input{
  @apply w-full;
  height:8rem;
}

.editInplace__icon{
  @apply text-gray-300 ml-2;
}

.editInPlace__form{
 @apply flex flex-wrap items-center justify-end;
 width:30rem;
 max-width:70vw;
}
</style>
